import { Injectable } from '@angular/core';
import {
  subMonths,
  addMonths,
  addDays,
  addWeeks,
  subDays,
  subWeeks,
} from 'date-fns';
import { Constants } from '../constants/constants';
import { BehaviorSubject, Subject } from 'rxjs';
import * as moment from 'moment';

type CalendarPeriod = Constants.day | Constants.week | Constants.month;

@Injectable({
  providedIn: 'root'
})
export class CalendarUtilsService {

  calendarViewSubject = new BehaviorSubject<any>(Constants.week);
  calendarChangeEvents = new Subject<any>();
  calendarDayClicked = new Subject<any>();
  calendarDaysSubject = new Subject<any>();

  constructor() { }

  addPeriod(period: CalendarPeriod, date: Date, amount: number): Date {
    return {
      day: addDays,
      week: addWeeks,
      month: addMonths,
    }[period](date, amount);
  }

  subPeriod(period: CalendarPeriod, date: Date, amount: number): Date {
    return {
      day: subDays,
      week: subWeeks,
      month: subMonths,
    }[period](date, amount);
  }

  scrollToCalendarDay(dayDate: any, shouldBeAbleToAccessDay: boolean): void {
    setTimeout(() => {
      const idDay = moment(dayDate).format('MMMMDD');
      const el = document.getElementById(idDay);
      if (el) {
        el.scrollIntoView({ block: 'start', inline: 'start', behavior: 'smooth' });
      } else if (shouldBeAbleToAccessDay) {
        this.calendarDayClicked.next(dayDate);
      }
    }, 0);
  }
}
